// src/components/ProtectedRoute.jsx
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import LoadingScreen from './LoadingScreen'

const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { isAuthenticated, isLoading, user } = useAuth()

    if (isLoading) {
        return <LoadingScreen />
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    if (requireAdmin && user?.role !== 'admin' && user?.role !== 'support') {
        return <Navigate to="/dashboard" replace />
    }

    return children
}

export default ProtectedRoute